import * as React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import Aboute from "./Allaboute/Aboute";
import Services from "./Allservices/Services";
import Blog from "./Allblog/Blog";
import Contact from "./Allcontact/Contact";
import { Data } from "./Alldata/Data";
import Shop from "./AllCart/Shop";
import Pasket from "./Allpasket/Pasket";
import ScrollToTop from "react-scroll-to-top";
import Checkout from "./Allcheckout/Checkout";
import Thankyou from "./Allthank/Thankyou";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },

  {
    path: "aboute",
    element: <Aboute />,
  },
  {
    path: "services",
    element: <Services />,
  },
  {
    path: "blog",
    element: <Blog />,
  },
  {
    path: "contact",
    element: <Contact />,
  },
  {
    path: "shop",
    element: <Shop />,
  },
  {
    path: "pasket",
    element: <Pasket />,
  },
  {
    path: "check",
    element: <Checkout />,
  },
  {
    path: "Thank",
    element: <Thankyou />,
  },
]);

createRoot(document.getElementById("root")).render(
  <Data>
  <div>
    <RouterProvider router={router} />
    <ScrollToTop
     smooth 
     viewBox="0 0 384 512"
     svgPath="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
      color="white"
      style={{backgroundColor:"#3b5d50" , borderRadius:"50%"}}
     />
  </div>
  </Data>
);
